<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--progress-claim">
        <div class="card-header">
            <h6 class="fw-bold mb-0 dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.progressClaim"></span>
                <span>{{ $t('Client Progress Claims') }}</span>
            </h6>
        </div>
        <div class="card-body p-0">
            <div
                class="client-progress-claims__table-scroll"
                role="region"
                aria-label="Client progress claims"
                tabindex="0"
            >
              <table class="table table-striped">
                <thead>
                    <tr>
                        <th>{{ $t('S/N') }}</th>
                        <th>{{ $t('Progress Claim No.') }}</th>
                        <th>{{ $t('Date') }}</th>
                        <th class="text-end">{{ $t('Submitted Amount') }}</th>
                        <th>{{ $t('Status')}}</th> 
                        <th>{{ $t('Last Updated') }}</th>
                        <th class="text-end">{{ $t('Approved Amount') }}</th>
                        <th class="dashboard-widget-table__actions">{{ $t('Actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data.length==0">
                        <td colspan="8" class="text-center dashboard-widget__empty-state">
                            {{ $t('No data Found') }}
                        </td>
                    </tr>
                    <tr v-for="(item,key) in data" :key="key" >
                        <td>{{ key + 1 }}</td>
                        <td><a :href="dotNetUrl + '/progressclaim/item/' + item.id" class="link-style-custom">{{ item.progressClaimNumber }}</a></td>
                        <td>{{ ReformatDate(item.progressClaimDate) }}</td>
                        <td  class="text-end">{{projectInfo.currencyId?.sign}}{{ ReformatNumber(item.totalAmount) }}</td>
                        <td> <span :class="color[item.status - 1]" >{{ item.statusName }}</span> </td>
                        <td>{{ ReformatDate(item.date) }}</td>
                        <td  class="text-end">
                            <span v-if="item.status==6">{{projectInfo.currencyId?.sign}}{{ ReformatNumber(item.totalAmount) }}</span>
                            <span v-else>-</span>
                            
                        </td>
                        <td class="dashboard-widget-table__actions">
                            <a :href="dotNetUrl + '/progressclaim/item/' + item.id" :title="$t('View')" :aria-label="$t('View')">
                                <i class="fa-regular fa-eye" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
            <div class="dashboard-widget__footer dashboard-widget__footer--end"> <a :href="dotNetUrl + '/progressclaim/'+projectInfo.projectOldId" class="dashboard-widget__link">{{ $t('View All') }}</a></div>
        </div>
    </div>
</template>

<script>
import {DashboardGetProjectProgressClaims} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import 'dotenv/config'
export default {
    name : 'ClientProgressClaims',
    props : ['projectInfo'],
    data(){
        return {
            data : [],
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            color : ['text-muted','text-primary','text-warning','text-success','text-primary','text-success'],
            sidebarSvg
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetProjectProgressClaims(self.projectInfo._id)
        if(!response)
            return
        self.data = response.data
    },
    methods :{
        ReformatNumber,ReformatDate
    }
    
} 
</script>

<style scoped>
.client-progress-claims__table-scroll {
    width: 100%;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-color: #9175c7 #f0edfa;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
}

.client-progress-claims__table-scroll:focus-visible {
    outline: 2px solid #5617c3;
    outline-offset: 2px;
}

.client-progress-claims__table-scroll .table {
    min-width: 60rem;
    margin-bottom: 0;
}
</style>
